import { createFileRoute } from '@tanstack/react-router';

import { EffectivenessPage } from '../../features/manager-effectiveness/components/EffectivenessPage';

export const Route = createFileRoute('/_onboarding/effectiveness')({
  component: EffectivenessRoute,
});

function EffectivenessRoute() {
  return <EffectivenessPage />;
}
